<template>
	<section class="news-feed">
		<h4 class="section-title">Messages</h4>
		<NotificationSources ref="notificationSources" @change="onNotificationSourceChange" />
		<NotificationList @newNotification="onNewNotification" :selectedSources="selectedSources" />
	</section>
</template>

<script>
import NotificationList from './NotificationList';
import NotificationSources from './NotificationSources';

export default {
	name: 'NewsFeed',
	components: {
		NotificationList,
		NotificationSources,
	},
	data() {
		return {
			selectedSources: [],
		};
	},
	methods: {
		onNewNotification(msg) {
			if (this.$refs.notificationSources) {
				this.$refs.notificationSources.load();
			}
		},
		onNotificationSourceChange(sources) {
			this.selectedSources = [...sources];
		},
	},
};
</script>

<style lang="scss" scoped>
.news-feed {
	display: block;
	width: 100%;
	margin: 20px auto;
}
</style>
